export const GIFT_MEMBERSHIP_GET_STARTED_CLICK =
  "gift_membership_get_started_click";
export const GIFT_MEMBERSHIP_BOOK_HOTEL_CLICK =
  "gift_membership_book_hotel_click";

export type GiftRedemptionSuccessCtaEvent =
  | typeof GIFT_MEMBERSHIP_GET_STARTED_CLICK
  | typeof GIFT_MEMBERSHIP_BOOK_HOTEL_CLICK;

const GET_STARTED_LABEL = /get started|commencer|empezar|시작|始める|mulai/i;
const BOOK_HOTEL_LABEL =
  /book.*hotel|hotel.*book|search hotel|réserver|reservar|booking/i;

const hostFromHref = (href?: string | null) => {
  if (!href) return undefined;

  try {
    return new URL(href).hostname.toLowerCase();
  } catch {
    return undefined;
  }
};

export const getGiftRedemptionSuccessCtaEvent = ({
  href,
  label,
  role,
}: {
  href?: string | null;
  label?: string | null;
  role: "primary" | "secondary";
}): GiftRedemptionSuccessCtaEvent => {
  const host = hostFromHref(href);

  if (host?.includes("all.accor.com") && !host.includes("accorplus")) {
    return GIFT_MEMBERSHIP_BOOK_HOTEL_CLICK;
  }

  if (host?.includes("accorplus")) {
    return GIFT_MEMBERSHIP_GET_STARTED_CLICK;
  }

  if (BOOK_HOTEL_LABEL.test(label ?? "")) {
    return GIFT_MEMBERSHIP_BOOK_HOTEL_CLICK;
  }

  if (GET_STARTED_LABEL.test(label ?? "")) {
    return GIFT_MEMBERSHIP_GET_STARTED_CLICK;
  }

  return role === "secondary"
    ? GIFT_MEMBERSHIP_BOOK_HOTEL_CLICK
    : GIFT_MEMBERSHIP_GET_STARTED_CLICK;
};
